<template lang="html">
  <div class="w-full account-items">
  	<div v-if="item_rejected !== null">
		<vs-popup class="holamundo"  :title="$t('reject')+ ' ' +item_rejected.item.name" :active.sync="popupActive">
	      <div>
	      	<h4>{{$t('reject_items_question')}}</h4>
	      	<vs-textarea label="" v-model="item_rejected.rejected_observation"/>
	      </div>
	      <div class="text-right">
	      	<vs-button class="sm:w-full md:w-1/3 lg:w-1/4 m-1" color="success" type="filled" v-on:click="save_rejected">{{$t('save_item_rejected')}}</vs-button>
			<vs-button class="sm:w-full md:w-1/3 lg:w-1/4 m-1" color="danger" type="filled" v-on:click="popupActive=false">{{$t('cancels')}}</vs-button>
	      </div>
	    </vs-popup>
	</div>
	<div>
		<div class="w-full" v-if="accounts.length > 1 && (page !== 'checkout' || !can_checkout)">
			<small class="block">{{$t('client_accounts')}}</small>
			<v-select class="vue-select md:w-1/3" :clearable="false" :searchable="false" :value="account" :options="accounts" v-on:input="setAccount" label="nome_conta">
			</v-select>
		</div>
	</div>
	<div v-if="account !== null">
		<div v-if="comp_account_items.length > 0" class="justify-between items-center mt-3">
	        <span style="background:rgba(var(--vs-primary),.15);" class="p-3 inline-flex rounded-full feather-icon select-none relative text-warning">
	            <h4 style="color: rgba(var(--vs-primary),1);">{{total_account}} {{user.hotel.moeda}}</h4>
	        </span>
	    </div>
	
		<!-- <div class="w-full text-right">
			<vs-input v-model="search_item" class="w-full lg:w-1/5 inline-block mb-3 text-left" placeholder="Pesquisar"/>
		</div> -->
		<div>
		  	<vs-table v-if="!can_checkout || page !== 'checkout'" class="account-items" search max-items="10" stripe pagination :data="comp_account_items" :noDataText="$t('account_no_items')">
			  <template slot="thead">
					<vs-th>
						{{$t('item')}}
					</vs-th>
					<vs-th>
					    {{$t('local')}}
					</vs-th>
					<vs-th>
						{{$t('date')}}
					</vs-th>
					<vs-th>
						{{$t('account_quantity')}}
					</vs-th>
					<vs-th>
						{{$t('value')}} ({{user.hotel.moeda}})
					</vs-th>
					<vs-th>
						{{$t('reject')}} 
					</vs-th>
				</template>	

				<template slot-scope="{data}">
					<vs-tr :key="idx" v-for="(item, idx) in data">
						<vs-td v-html="item.show_name"></vs-td>

						<vs-td>
							{{item.warehouse.armazem}}
						</vs-td>

						<vs-td>
							{{item.date_created}}
						</vs-td>

						<vs-td>
							{{item.quantity}}
						</vs-td>
						<vs-td>
							{{parseFloat(item.total_price).toFixed(2)}}
						</vs-td>
						<vs-td>
							<div v-if="item.confirmed === null" class="reject_button" :title="(item.rejected !== null) ? $t('rejected') : $t('reject')">
								 <XCircleIcon v-if="item.rejected === null" v-on:click="show_reject_popup(item)" stroke="red" class="cursor-pointer"></XCircleIcon> 
								 <XCircleIcon v-else></XCircleIcon> 
							</div>
							<div v-else><span>---</span></div>
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
			<div>
				<div class="text-center" v-if="page === 'checkout' && can_checkout && !checkout_done">
					<vs-button class="mt-4 mx-auto" color="primary" :disabled="!all_items_paid_in_all_accounts" v-on:click="$emit('do_checkout')">Check-Out</vs-button>
				</div>
				<div class="text-center" v-else-if="!confirmed_account && comp_account_items.length > 0">
					<vs-button class="mt-4 mx-auto" color="primary" v-on:click="process_confirmation">{{$t('finishOrder')}}</vs-button>
				</div>

				
				<!-- conta rejeitada na pagina de checkout--> 
				<vs-alert v-if="confirmed_account && page === 'checkout' && account_has_rejected" active="true" color="warning" icon-pack="feather" icon="icon-alert-triangle" class="mx-auto mt-3 w-full">
		     		<span  v-html="$t('checkout_warning_w_rejected')"></span>
		   		</vs-alert>

				<!-- conta nao foi rejeitada na pagina de checkout mas nao ha pagamentos--> 
				<vs-alert v-if="confirmed_account && page === 'checkout' && !account_has_rejected && !(user.payments_available && (user.payments_available.sibs_cards || user.payments_available.sibs_mbway ))" active="true" color="warning" icon-pack="feather" icon="icon-alert-triangle" class="mx-auto mt-3 w-full">
		     		<span  v-html="$t('checkout_warning')"></span>
		   		</vs-alert>		

				<!-- conta confirmada e foi rejeitada na pagina de conta--> 
		   		<vs-alert v-else-if="account_has_rejected && confirmed_account && page !== 'checkout'" active="true" color="warning" icon-pack="feather" icon="icon-alert-triangle" class="mx-auto mt-3 w-full">
		     		<span v-html="$t('checkout_warning_w_rejected')"></span>
		   		</vs-alert>
		   		
				<!-- se existe depositos na conta nao pode pagar --> 
				<vs-alert v-if="page === 'checkout' && isDepositInItems" active="true" color="warning" icon-pack="feather" icon="icon-alert-triangle" class="mx-auto mt-3 w-full">
		     		<span  v-html="$t('checkout_warning')"></span>
		   		</vs-alert>		
				<!-- se existe depositos na conta nao pode pagar --> 
		   		<vs-alert v-else-if="page !== 'checkout' && isDepositInItems" active="true" color="warning" icon-pack="feather" icon="icon-alert-triangle" class="mx-auto mt-3 w-full">
		     		<span v-html="$t('checkout_warning_w_rejected')"></span>
		   		</vs-alert>



				<div v-if="!account_has_rejected && user.hotel.country.toLowerCase() == 'portugal' && !paymentPaid && total_account > 0 && confirmed_account 
					&& (user.payments_available && (user.payments_available.sibs_cards || user.payments_available.sibs_mbway ))" id="payment-box">

					<div class="vx-row mt-3">
						<div class="vx-col w-full">
							<div class="vx-card">
								<div class="vx-card__header">
									<div class="vx-card__title">
										<h4 class="">{{$t('payments')}}</h4>
									</div>
								</div>
								<div class="vx-card__collapsible-content vs-con-loading__container">
									<div class="vx-card__body">
										<p class="mb-5">{{$t('payment_msg')}}</p>
										<div class="vx-row">
											<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 text-center sm:text-right md:text-right lg:text-right mb-5 sm:mb-0 md:mb-0 lg:mb-0">
												<vs-button   class="vs-component vs-button payment-methods-style" style="width: 150px;border: 1px solid #58ccc2;" :color="!isClickedCC ? 'white':'#6EC9C2' " v-on:click="selectPaymentMethod('cardbrand')" v-if="user.payments_available && user.payments_available.sibs_cards">
													<span class="vs-button-text vs-button--text">
														<img src="https://vgcontent.s3-eu-west-1.amazonaws.com/sibs/visa-logo.png" style="position: relative; right: 15px;top: 2px;" height="45">
													</span>
												</vs-button>
											</div>
											<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 text-center sm:text-left md:text-left lg:text-left" >
												<vs-button class="payment-methods-style" :color="!isClickedMB ? 'white':'#6EC9C2' " type="filled" v-on:click="selectPaymentMethod('mbway')" v-if="user.payments_available && user.payments_available.sibs_mbway">
													<img id="mbway-logo" height="45" src="https://vgcontent.s3-eu-west-1.amazonaws.com/sibs/mbway-logo.png">
												</vs-button>
											</div>
										</div>
										<vs-row vs-w="12" class="mt-5 text-center" v-if="openPayment"   >
											<div  v-html='iframe' id="iframepayments" ></div>
										</vs-row>
										<div class="vx-row">
											<div class="vx-col w-full">
												<div class="flex justify-center sm:justify-end md:justify-end lg:justify-end ">
													<img src="https://vgcontent.s3-eu-west-1.amazonaws.com/sibs/cgd.jpg" class="mr-2 h-12">
													<a href="https://www.mastercard.co.uk/en-gb/consumers/features-benefits/securecode.html" target="_blank" style="cursor: pointer; text-decoration: none; border-bottom: 0px;">
														<img src="https://vgcontent.s3-eu-west-1.amazonaws.com/sibs/Mastercard-Securecode.jpg" class="mr-2 h-12">  
													</a>
													<a href="https://www.visa.pt/pagar-com-visa/tecnologias-apresentadas/verified-by-visa.html" target="_blank" style="cursor: pointer; text-decoration: none; border-bottom: 0px;">
														<img src="https://vgcontent.s3-eu-west-1.amazonaws.com/sibs/VisaSecure.jpg" class="mr-2 h-12">
													</a>
													<img src="https://vgcontent.s3-eu-west-1.amazonaws.com/sibs/mbway.jpg" class="h-12">
												</div>
											</div>
										</div>
									</div>
								
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
	
  </div>
</template>

<script>

//load configurations on theme
import { XCircleIcon } from 'vue-feather-icons'

export default {
	props: ['rsvID', 'user', 'page', 'checkout_done'],
	data() {
		return {
			account: null,
			popupActive: false,
			search_item: '',
			item_rejected: null,
			rejected_items: [],
			accounts: [],
			confirmed_account: false,
			iframe : null, 			//payments vars
			openPayment: false, 	//payments vars
			paymentPaid : false, 	//payments vars
			paymentData : null, 	//payments vars
			isClickedCC  : false, 	//payments vars
			isClickedMB  : false, 	//payments vars
			isClosedPayment : false,
			eventPaymentSent : false,
			isDepositInItems: false
		}
	},
	methods: {
		show_reject_popup: function(item) {
			this.item_rejected = item;
			this.confirmed_account = false;
			this.popupActive = true;
		},
		save_rejected: function() {
			this.item_rejected.rejected = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '');
			let item_idx = this.comp_account_items.findIndex((item, idx) => item.cod_client_account_items == this.item_rejected.cod_client_account_items);
			this.account.client_account_items[item_idx].rejected = this.item_rejected.rejected;
			this.rejected_items.push(this.item_rejected);
			this.popupActive = false;
		},
		setAccount: function(acc, confirmed) {
			if(this.account !== null && acc.cod_client_account === this.account.cod_client_account) {
				this.$vs.loading.close();
				return;
			}
			this.isClickedCC = false;
			this.isClickedMB = false;
			this.iframe = null;
			this.account = null;
			this.isClosedPayment = false;
			this.confirmed_account = confirmed || false;
			this.getItems(acc);
		},
		process_confirmation: function() {
			this.send_rejected_items();
			// this.confirmed_account = true;
		},
		send_rejected_items: function() {
			let that = this;
			this.$vs.loading();
			this.$api({
				method: 'post',
				url: '/myvilagale/orders/reject_items?token=' +this.user.usertoken,
				data: {
					hotel: this.user.hotel,
					confirmed_items: this.account.client_account_items.filter((item, idx) => item.rejected === null && item.confirmed === null),
					rejected_items: this.rejected_items
				},
			})
			.then(function (res) {
				that.rejected_items = [];
				that.getAccounts(that.accounts.findIndex((acc, idx) => acc.cod_client_account == that.account.cod_client_account));
				that.account = null;
                that.$vs.notify({
                    text: that.$t('confirmed_account_msg'),
                    color:'success',
                    position:'bottom-right',
                    iconPack: 'feather',
                    icon:'icon-check'
                });
			}) 
			.catch( function (err) {
                that.$vs.notify({
                    text: that.$t('order_error'),
                    color:'danger',
                    position:'bottom-right',
                    iconPack: 'feather',
                    icon:'icon-alert-triangle'
                });
			})
			.then(function() {
				// that.$vs.loading.close();
			});
		},
		getAccounts(idx_acc) {
			this.$vs.loading();
			let that = this;
			this.$api({
				method: 'get',
				url: '/myvilagale/orders/get_accounts',
				params: {
					token: this.user.usertoken,
					rsvID: this.rsvID
				},
			}).then(function (res) {
				if(res.data.length > 0) {
					that.accounts = res.data;
					if(idx_acc > 0) {
						that.setAccount(that.accounts[idx_acc], that.confirmed_account);	
					}else {
						that.setAccount(that.accounts[0], that.confirmed_account);
					}
					if(that.can_checkout) {
						that.$emit('set_sentence', that.$t('checkout_text_no_items'));
					}
					return;
				}
				that.$vs.notify({
                    text: 'Ocorreu um problema a carregar conta.',
                    color:'danger',
                    position:'bottom-right',
                    iconPack: 'feather',
                    icon:'icon-alert-triangle'
                });
			}) 
			.catch( function (err) {
                that.$vs.notify({
                    text: 'Ocorreu um problema a carregar conta.',
                    color:'danger',
                    position:'bottom-right',
                    iconPack: 'feather',
                    icon:'icon-alert-triangle'
                });
            });
			
		},
		getItems(acc) {
			this.$vs.loading();
			acc.client_account_items = [];
			let that = this;
			this.$api({
				method: 'get',
				url: '/myvilagale/orders/get_my_account',
				params: {
					token: this.user.usertoken,
					cod_client_account: acc.cod_client_account,
					client_account_items_count: this.accounts[0].client_account_items_count,
				},
			})
			.then(function (res) {
				that.account = res.data;
				that.confirmed_account = res.data.client_account_items.length > 0 && !res.data.client_account_items.some((item, idx) => item.rejected === null && item.confirmed === null);
			}) 
			.catch( function (err) {
                that.$vs.notify({
                    text: 'Ocorreu um problema a carregar conta.',
                    color:'danger',
                    position:'bottom-right',
                    iconPack: 'feather',
                    icon:'icon-alert-triangle'
                });
			})
			.then(function() {
				that.$vs.loading.close();
			});
		},
		selectPaymentMethod(type){
			let that   = this;
			let cambio = 'EUR';
			let tokenX = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.' +
                              'eyJzdWIiOiJjdXN0b20iLCJpc3MiOiJodHRwOlwvXC9hcGkudmdcL2F1dGhcL3Rva2VuXC9nZW5lcmF0ZSIsImlhdCI6MTQ3OTE0MDgwMSwiZXhwIjoxNzg2NzIxMjAxLCJuYmYiOjE0NzkxNDA4MDEsImp0aSI6ImU4MmI2NmE2NzI4ZDVjZjcwYmY0NGYwY2E3NWY1ZTZiIiwicGVybWlzc2lvbiI6IjEiLCJuYW1lIjoiQ2VudHJhbCBSZXNlcnZhcyJ9.' +
                              'DgKRtHolrkeIwmNnTWenMm0pFC1YwZHIGj9N8xDzDNI';
 
			let suburl = 'amount='+this.total_account+'&currency='+cambio+'&hotel='+this.user.hotel.hotel_id+'&type=DB&token='+tokenX+'&cod_reserva='+this.account.cod_reservation;

			if(type == 'cardbrand'){
				this.isClickedCC = true;
				this.isClickedMB = false;
			}
			else {
				this.isClickedCC = false;
				this.isClickedMB = true;
			}

			this.$api({
				method: 'get',
				url: '/netcaixa/payment/encryption?'+suburl,
			})
			.then(function (res) {
				let url = process.env.VUE_APP_PAYMENT_URL+'/'+type+'.php?paytoken='+res.data+'&lang='+that.$i18n.locale+'&hotel='+that.user.hotel.hotel_id+'&totalLabel='+that.total_account+'&email='+that.user.email+'&account='+that.account.cod_client_account+'&source=MYVILAGALE';

				let height = '525'; 
				if(type == 'cardbrand'){
					height = '835';
				}
 

				window.removeEventListener('message', that.postMessageEvent, false);
				that.paymentCommunication();
 
				that.iframe = null;


				that.iframe =  '<iframe id="myCustomIframe" frameborder="0" class="myCustomIframe" name="myCustomIframe" src="'+url+'" width="100%" height="'+height+'" sandbox="allow-forms  allow-modals  allow-orientation-lock  allow-pointer-lock  allow-popups   allow-popups-to-escape-sandbox  allow-presentation   allow-same-origin    allow-scripts    allow-top-navigation  allow-top-navigation-by-user-activation"></iframe> '; 
                that.openPayment = true;

			}) 
			.catch( function (err) {
    			that.notify('Ocorreu a carregar o pagamento.', 'red');
			})
			.then(function() {
				that.$vs.loading.close();
			});
		},

		postMessageEvent(event){
			let that = this;
			
			if ( (event.data.status === 200 || event.message === "myevent") ) {

				that.$vs.loading.close();
				that.$vs.loading();
				that.paymentData = event.data;
				that.submission(event.message);

			} 
		},
		paymentCommunication(variable){

			let that = this;
			window.addEventListener("message", that.postMessageEvent, { once: true }); 
	 
		},
		submission(messageEvent){
 			let that = this;
 			let message = '';
 			let typemessage = 'success';
 			let paymentbox = document.getElementById("payment-box");
			paymentbox.scrollIntoView();
 			
 			if(this.account.client_account_items && this.account.client_account_items.length <= 0 ){
 				return false;
			}

			if(this.isClickedCC){
				message = this.$t('payment_success');
			}
			if(this.isClickedMB){
				typemessage = 'warning';
				message = this.$t('payment_pending');
			}
 
			that.$vs.notify({
                text: message,
                color: typemessage,
                position:'bottom-right',
                iconPack: 'feather',
                icon:'icon-check'
            });

			that.paymentPaid = true;
			that.isClosedPayment = true;
               
			that.getAccounts();
			 
			that.getItems(that.account);
			that.$vs.loading.close();
 
		}
	},
	computed: {
		comp_account_items: function() {
			let items = [];
			let cut_payment_because_deposit = false;
			if(typeof this.account.client_account_items === 'undefined') {
				this.account.client_account_items = [];
			}
			for(let item of this.account.client_account_items) {
				if(item.item.show_client == 1) {
					item.show_name = item.item.name;
					if(item.cod_client_account_items_desc !== null) {
						item.show_name = item.show_name+ '<br><small><b><i>' +this.$t('discount')+ ' - ' +item.razao_desconto+ '</i></b></small>';
					}
 
					if(item.item.cod_items != 316 && item.item.cod_items != 317 && item.item.cod_items != 318 && item.item.cod_items != 12552 && item.item.cod_items != 12746){
						items.push(item);
					} else {
						cut_payment_because_deposit = true;

					}
					
				}
			}

			if(cut_payment_because_deposit){
				this.user.payments_available.sibs_cards = false;
				this.user.payments_available.sibs_mbway = false;
				this.isDepositInItems = true;
			}

			return items;
		},
		total_account: function() {
			return (Math.round((this.comp_account_items.reduce((current_sum, item) => current_sum + parseFloat(item.total_price), 0) + Number.EPSILON) * 100) / 100).toFixed(2);
		},
		account_has_rejected: function() {
			let rejected = this.comp_account_items.filter((item, idx) => item.rejected !== null);
			return rejected.length !== 0 || this.rejected_items.length !== 0;
		},
		can_checkout: function() {
			return this.accounts.every((item, idx) => item.client_account_items_count == 0);
		},
		all_items_paid_in_all_accounts: function(){
			return this.accounts[0].all_client_account_items_count == 0;
		},
	},
	watch: {
		'$i18n.locale': function(new_val, old_val) {
			if(this.can_checkout) {
				this.$emit('set_sentence', this.$t('checkout_text_no_items'));
			}
		}
	},
	components: {
		XCircleIcon
	},
	created: function() {
		this.getAccounts();

		
	},
	beforeDestroy(){
 
 		let that = this;
		window.removeEventListener('message', that.postMessageEvent, false);

	}
 
}

</script>
<style scoped>
	.vue-select {
		display: inline-block;
	}
	@media (max-width: 767.98px) {
		.vue-select {
			display: block;
		}	
	}
	#iframepayments{
		width: 100%;
	}
	#mbway-logo{
		top: 4px; position: relative;
	}
	.payment-methods-style{
		min-width: 150px; border: 1px solid #58ccc2;
	}	
 
</style>
<style>
	.account-items .con-pagination-table .vs-pagination--mb {
		width: 100% !important;
	}
</style>